/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MetricValueTextAggregatedValuesDto
 */
export interface MetricValueTextAggregatedValuesDto {
    /**
     * Latest text value recorded
     * @type {string}
     * @memberof MetricValueTextAggregatedValuesDto
     */
    latest?: string;
}

/**
 * Check if a given object implements the MetricValueTextAggregatedValuesDto interface.
 */
export function instanceOfMetricValueTextAggregatedValuesDto(value: object): value is MetricValueTextAggregatedValuesDto {
    return true;
}

export function MetricValueTextAggregatedValuesDtoFromJSON(json: any): MetricValueTextAggregatedValuesDto {
    return MetricValueTextAggregatedValuesDtoFromJSONTyped(json, false);
}

export function MetricValueTextAggregatedValuesDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): MetricValueTextAggregatedValuesDto {
    if (json == null) {
        return json;
    }
    return {
        
        'latest': json['latest'] == null ? undefined : json['latest'],
    };
}

export function MetricValueTextAggregatedValuesDtoToJSON(json: any): MetricValueTextAggregatedValuesDto {
    return MetricValueTextAggregatedValuesDtoToJSONTyped(json, false);
}

export function MetricValueTextAggregatedValuesDtoToJSONTyped(value?: MetricValueTextAggregatedValuesDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'latest': value['latest'],
    };
}

